import React, { useState } from 'react';
import { Calendar, ChevronDown, ChevronUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Modal } from '../ui/Modal';
import { useToast } from '../../context/ToastContext';
export function LeaveBalanceWidget() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    showToast
  } = useToast();
  const navigate = useNavigate();
  const leaveBalances = [{
    type: 'Congés payés',
    balance: 18,
    unit: 'jours'
  }, {
    type: 'RTT',
    balance: 5,
    unit: 'jours'
  }, {
    type: 'Maladie',
    balance: 3,
    unit: 'jours'
  }];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsModalOpen(false);
    showToast('Demande de congé soumise avec succès', 'success');
    setTimeout(() => navigate('/conges'), 500);
  };
  return <>
      <div className="bg-white rounded-lg shadow-sm p-5 hover:shadow-md transition-shadow min-h-[400px] flex flex-col" data-id="element-1968">
        <div className="flex items-center justify-between mb-4" data-id="element-1969">
          <h3 className="font-semibold text-gray-900" data-id="element-1970">Solde de congés</h3>
          <div className="flex items-center gap-2" data-id="element-1971">
            <Calendar className="h-5 w-5 text-blue-600" data-id="element-1972" />
            <button onClick={() => setIsExpanded(!isExpanded)} className="text-gray-400 hover:text-gray-600" data-id="element-1973">
              {isExpanded ? <ChevronUp className="h-4 w-4" data-id="element-1974" /> : <ChevronDown className="h-4 w-4" data-id="element-1975" />}
            </button>
          </div>
        </div>
        <div className="space-y-3 flex-1" data-id="element-1976">
          {leaveBalances.slice(0, isExpanded ? undefined : 2).map((leave, index) => <div key={index} className="flex justify-between items-center" data-id="element-1977">
                <span className="text-sm text-gray-600" data-id="element-1978">{leave.type}</span>
                <div className="flex items-center" data-id="element-1979">
                  <span className="font-semibold text-lg text-gray-900" data-id="element-1980">
                    {leave.balance}
                  </span>
                  <span className="ml-1 text-xs text-gray-500" data-id="element-1981">
                    {leave.unit}
                  </span>
                </div>
              </div>)}
        </div>
        <button onClick={() => setIsModalOpen(true)} className="mt-4 w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium transition-colors duration-150 ease-in-out" data-id="element-1982">
          Demander un congé
        </button>
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Demander un congé" size="md" data-id="element-1983">
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1984">
          <div data-id="element-1985">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1986">
              Type de congé
            </label>
            <select className="w-full px-4 py-3 text-base rounded-lg border-2 border-gray-200 focus:border-blue-500 focus:ring-0 transition-colors" data-id="element-1987">
              <option data-id="element-1988">Congés payés</option>
              <option data-id="element-1989">RTT</option>
              <option data-id="element-1990">Maladie</option>
              <option data-id="element-1991">Congé sans solde</option>
            </select>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1992">
            <div data-id="element-1993">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1994">
                Date de début
              </label>
              <div className="relative" data-id="element-1995">
                <input type="date" required className="w-full px-4 py-3 text-base rounded-lg border-2 border-gray-200 focus:border-blue-500 focus:ring-0 transition-colors appearance-none" data-id="element-1996" />
                <Calendar className="absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" data-id="element-1997" />
              </div>
            </div>
            <div data-id="element-1998">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1999">
                Date de fin
              </label>
              <div className="relative" data-id="element-2000">
                <input type="date" required className="w-full px-4 py-3 text-base rounded-lg border-2 border-gray-200 focus:border-blue-500 focus:ring-0 transition-colors appearance-none" data-id="element-2001" />
                <Calendar className="absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" data-id="element-2002" />
              </div>
            </div>
          </div>
          <div data-id="element-2003">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2004">
              Commentaire (optionnel)
            </label>
            <textarea rows={3} className="w-full px-4 py-3 text-base rounded-lg border-2 border-gray-200 focus:border-blue-500 focus:ring-0 transition-colors" data-id="element-2005" />
          </div>
          <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-4" data-id="element-2006">
            <button type="button" onClick={() => setIsModalOpen(false)} className="w-full sm:w-auto px-6 py-3 border-2 border-gray-300 rounded-lg text-base font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-2007">
              Annuler
            </button>
            <button type="submit" className="w-full sm:w-auto px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-base font-medium shadow-sm transition-colors" data-id="element-2008">
              Soumettre
            </button>
          </div>
        </form>
      </Modal>
    </>;
}